import React from 'react';
import { useFm, useParams } from '@web3/base-hooks';
import { appPath, justFormatNumber } from '@web3/base-utils';
import { Tag } from '@bfe/moly';
import {
  DEFAULT_PROJECT_ICON,
  RANK_CUP_ICON_1_IMG,
  RANK_CUP_ICON_2_IMG,
  RANK_CUP_ICON_3_IMG,
  SYMBOL_ICON_MORE_CHAINS,
} from '@/constants';
import { Button, MultiChains } from '@/components';
import { initialWindowType } from '@/hooks/media';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

import styles from './top3.module.scss';
import { ActiveStatus } from '@/hooks/home';
import { AbbreviatedNumber } from '@/components/AbbreviatedNumber';

const Top3 = ({ list: top3, activeStatus, remainVoteCount }) => {
  const fm = useFm();
  const { isMobile } = initialWindowType;
  const { locale } = useParams();

  const handleClickVote = (projectCode, projectName) => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.HomePage,
      button_name: 'AIDOLProject',
      spmName: projectName,
    });
    window.open(
      `/${locale}${appPath}/aidol?name=${encodeURIComponent(projectCode)}`,
      '_blank'
    );
  };
  const CUP_ICON_LIST = [
    RANK_CUP_ICON_1_IMG,
    RANK_CUP_ICON_2_IMG,
    RANK_CUP_ICON_3_IMG,
  ];
  return (
    <div className={styles.top3Wrapper}>
      {top3?.map((item, index) => (
        <div
          className={styles.top3Item}
          key={index}
          onClick={() => handleClickVote(item?.code, item?.name)}
        >
          <img
            className={styles.cupIcon}
            src={CUP_ICON_LIST[index]}
            alt="cup"
          />
          <div className={styles.top}>
            <div className={styles.icon}>
              <img
                src={item?.icon}
                alt="icon"
                onError={(e) => {
                  if ((e?.target as any)?.src)
                    (e.target as any).src = DEFAULT_PROJECT_ICON;
                }}
              />
              {item?.chainList?.length > 1 ? (
                <MultiChains chainList={item?.chainList}>
                  <img
                    className={styles.chainIcon}
                    src={SYMBOL_ICON_MORE_CHAINS}
                    alt="chain icon"
                  />
                </MultiChains>
              ) : (
                <>
                  {item?.chainList?.length > 0 && (
                    <img
                      className={styles.chainIcon}
                      src={item?.chainList?.[0]?.chainIcon}
                      alt="chain icon"
                    />
                  )}
                </>
              )}
            </div>
            <div className={styles.title}>{item?.name}</div>
          </div>
          <div className={styles.middleRow}>
            <div className={styles.middleCol}>
              <div className={styles.value}>
                <AbbreviatedNumber num={item?.point ?? 0} />
              </div>
              <div className={styles.mark}>{fm('votingPoints')}</div>
            </div>
            {!isMobile && (
              <div className={styles.middleCol}>
                <div className={styles.value}>
                  {justFormatNumber(item?.joinAddressCount)}
                </div>
                <div className={styles.mark}>{fm('addressCount')}</div>
              </div>
            )}
          </div>
          <Button
            size={!isMobile ? 'middle' : 'x-small'}
            variant="primary"
            block
            className="mt-[4px]"
          >
            <>
              {activeStatus === ActiveStatus.UN_COMING && (
                <span>{fm('upcoming')}</span>
              )}
              {activeStatus === ActiveStatus.ENDED && (
                <span>{fm('ended')}</span>
              )}
              {activeStatus === ActiveStatus.ON_GOING && (
                <span>{fm('vote')}</span>
              )}
            </>
          </Button>
        </div>
      ))}
    </div>
  );
};

export default Top3;
